import NumberField from "./FormFields/NumberField";
import SelectField from "./FormFields/SelectField";
import DateField from "./FormFields/DateField";
import TextAreaField from "./FormFields/TextAreaField";
import { TextField } from "./FormFields/TextField";
import { memo } from "react";

const DynamicField = ({
  fieldType,
  column,
  value,
  onChange,
  options,
  disabled,
}) => {
  switch (fieldType) {
    case "number":
      return (
        <NumberField
          name={column.Field}
          value={value}
          onChange={onChange}
          disabled={disabled}
        />
      );

    case "date":
      return (
        <DateField
          name={column.Field}
          value={value}
          onChange={onChange}
          disabled={disabled}
        />
      );

    case "textarea":
      return (
        <TextAreaField
          name={column.Field}
          value={value}
          onChange={onChange}
          disabled={disabled}
        />
      );

    case "select":
      return (
        <SelectField
          name={column.Field}
          value={value}
          options={options}
          onChange={onChange}
          disabled={disabled}
        />
      );

    default:
      return (
        <TextField
          name={column.Field}
          value={value}
          onChange={onChange}
          disabled={disabled}
        />
      );
  }
};

export default memo(DynamicField);
